<template>
  <div class="menu-item__wrapper" :data-title="$props.title">
    <router-link v-if="!extraAction" :to="{ name: $props.to, params: $props.params }"
      class="menu-item" active-class="menu-item--active">
      <v-icon :name="$props.iconName" class="menu-icon"/>
    </router-link>
    <div v-else class="menu-item" @click="extraAction()">
      <v-icon :name="$props.iconName" class="menu-icon"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    to: {
      required: true,
      type: String,
    },
    iconName: {
      required: true,
      type: String,
    },
    params: {
      required: true,
      type: Object,
    },
    title: {
      required: true,
      type: String,
    },
    extraAction: {
      type: Function,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;

  &__wrapper {
    position: relative;

    &::after {
      content: attr(data-title);
      z-index: 99;
      position: absolute;
      top: 50%;
      left: 55px;
      padding: 5px 10px;
      max-width: 0;
      color: #000;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.25);
      white-space: nowrap;
      overflow: hidden;
      opacity: 0;
      transform: translateY(-50%);
      transition: max-width ease-in-out .3s;
    }

    &:hover {

      &::after {
        max-width: 500px;
        opacity: 1;
      }

    }

  }

  &::after {
    z-index: 1;
    content: '';
    position: absolute;
    left: 15px;
    height: 30px;
    width: 30px;
    border-radius: 10px;
    background: $surface;
  }

  &:hover {
    cursor: pointer;

    &::after {
      background: $surfaceDark;
    }

  }

  &--active {

    &::after {
      background: $surfaceDark;
    }

    .menu-icon {
      color: #fff;
    }

  }

}

.menu-icon {
  z-index: 2;
  color: $neutralLight;
  transition: background 0.2s ease-in-out;
}
</style>